module.exports = __webpack_public_path__ + "img/toldUsBackground.414cd821.svg";